export default "__VITE_ASSET__AyvDFSb7__"